export default {
  progressMetadata: {
    buttons: {
      createDevPlan: 'Create a development plan',
    },
    tooltips: {
      progress: '% of respondents who evaluated your competencies',
      closed: 'This test was closed by the organizer.',
      license: 'To run tests and obtain licenses, contact the organizer',
      notAvailable: 'To run tests, contact the organizer',
    },
    stubs: {
      noSkills:
        'To pass the self-assessment, choose a specialization. To do this, click on the «Change» button',
      noTests: 'No evaluation has been assigned where you need to evaluate your colleagues',
      selfApproval:
        "A list of approval tests will be displayed here, in which you'll be able to adjust the composition of the assessment participants and send the assessment for approval by the supervisor.",
      notSelfApproval:
        "A list of approval tests will be displayed here, in which you'll be able to adjust the composition of the assessment participants, run or reject the 360 test score.",
      feedback: 'No surveys have been assigned where you need to give feedback to your colleagues',
    },
    // dialogs
    infoDialog: {
      title: 'Approval is not required',
      text: 'This test no longer requires approval, it has been closed, canceled or has already been launched, if you need to find out more details, contact your assessment organizer.',
    },
    selectBlockSelfTestingDialog: {
      description:
        'Evaluate your knowledge of each of the listed skills by clicking the «Take the test» button. After evaluating all skills, a report will be created.',
    },
    selectBlockTesting360Dialog: {
      description:
        'To start the assessment, select the skill assessment blocks.</br> In the assessment form, choose the most appropriate answer for each question.</br> The answers are automatically saved after each block is completed.</br> After you have answered all the questions in the questionnaire, the assessment will be completed.',
      additionalInfo: {
        form: 'The form displays values based on previous estimates.',
        youCan: 'You can:',
        first: 'take the assessment again to update your level of competence,',
        second:
          'or complete the assessment without passing, if your level of competence has not changed since the previous assessment.',
      },
    },
    selectTestPersonalDialog: {
      description:
        'You will have to pass the testing. The main purpose of this testing is to identify your strengths and areas of development.',
      subtitle: 'The testing consists of',
      annotation: {
        title: 'Testing will take about 40 minutes.',
        text: '<p>Make sure that you feel well and make sure that nothing distracts you.</p><p>Click the button «{button}» to start testing.</p>',
      },
    },
    rejectTestDialog: {
      title: 'Reject of the score',
      tooltip: 'To reject of the score, enter a comment',
      button: 'Reject',
      placeholder: 'Enter the reason for the rejection',
    },
    // confirm dialogs
    confirmStartTesting: {
      title: 'Do you want to start the test?',
      text: 'The license will be redeemed at the start of the test. <br> You can stop testing at any time by closing the testing window and continue passing the test later.',
      button: 'Yes, continue',
    },
    confirmContinueTesting: {
      title: 'Continue the test?',
      text: 'The interrupted testing session will continue. The license for this test was already debited earlier.',
      button: 'Yes, continue',
    },
    confirmGetReport: {
      title: 'Create a report?',
      text: 'Not all test participants filled out the questionnaire, the data obtained may be unreliable.',
      button: 'Yes, create',
    },
    confirmCreateRoadmap: {
      title: 'Create a development plan?',
      text: 'Create a development plan based on this test',
      button: 'Yes, create',
    },
    // messages
    successMessages: {
      saveResults: {
        title: 'The test is completed',
        defaultText: 'Your answers are saved. Thank you for your time!',
        hiddenReportText:
          'The results of the survey will be discussed at an individual meeting with the supervisor as soon as all surveys are processed.',
      },
      rejectTest: {
        title: 'You rejected to pass the 360 score',
      },
    },
    errorMessages: {
      getBHPersonalBlock: 'Failed to go to the testing page',
      getVariantsPersonalReport: 'Failed to get reports variants',
      getUrlPersonalTest: 'Failed to start a test session',
      getLinkPersonalReport: 'Failed to get a link to the report',
      createReport: 'Failed to create report',
      createRoadmap: 'Failed to create a development plan',
      saveResults: 'Failed to save answers',
      rejectTest: 'Failed to reject the score',
    },
  },
};
